import PreviewSection from '../../PreviewSection'
import {ReportGroupingLevel} from '../../../constants'

export default function TTDetailHTMLPreviewHeader() {}

TTDetailHTMLPreviewHeader.prototype = new PreviewSection();

TTDetailHTMLPreviewHeader.prototype.constructor = TTDetailHTMLPreviewHeader;

TTDetailHTMLPreviewHeader.prototype.init = function( notEmptyGroupingLevels, detailLevels, joinCommentsByTask, needSwitchToMe){
    PreviewSection.prototype.init.call( this );

    this.detailLevels = detailLevels;
    this.notEmptyGroupingLevels = notEmptyGroupingLevels;
    this.joinCommentsByTask = joinCommentsByTask;
    this.needSwitchToMe = needSwitchToMe

    return this;
};

TTDetailHTMLPreviewHeader.prototype.addRows = function( tBody )
{
    let headerRowClass = "headerRow"
    if (this.notEmptyGroupingLevels.length === 0) {
        headerRowClass += " raw"; // set class if data is raw
    } else {
        headerRowClass += (" details" + (this.detailLevels.length - 1)); // set number of detail cells in additional class
        headerRowClass += (" floatCells" + this._getNumberOfFloatingCells(this.detailLevels.slice(1)));
    }
    const row = this.createRow(headerRowClass)

    const headerGroupingLevels = this.notEmptyGroupingLevels.slice() // copy array
    headerGroupingLevels.push(this.detailLevels[0]);
    this.addCell( row, ReportPreviewUtils.makeGroupingHeader(headerGroupingLevels), "firstHeaderCell" );

    for( let i = 1; i < this.detailLevels.length; i++ ) {
        let detailsLevel = this.detailLevels[i]
        const levelPreviewName = detailsLevel === ReportGroupingLevel.USER && this.needSwitchToMe ?
                                 this.message("report.common.me") :
                                 ReportPreviewUtils.getLevelPreviewName(detailsLevel)
        this.addCell(
                row,
                levelPreviewName,
                this._getAdditionalClass( detailsLevel )
        );
    }

    this.addCell(row, this.message( "reports.comments_report.report.spent" ), "spentTime");

    let commentsCellCls = "commentsCellHeader"
    if (this.joinCommentsByTask) commentsCellCls += " joined"
    this.addCell(row, this.message("reports.comments_report.report.comments"), commentsCellCls);

    this.addRow( tBody, row );
};

TTDetailHTMLPreviewHeader.prototype._getAdditionalClass = function( detailsLevel ) {
    switch (detailsLevel) {
        case ReportGroupingLevel.BILLING_TYPE:
            return "typeOfWork";
        case ReportGroupingLevel.DATE:
            return "day";
        case ReportGroupingLevel.USER:
            return "user";
        case ReportGroupingLevel.TASK:
            return "task";
        case ReportGroupingLevel.USER_GROUP:
            return "group";
        case ReportGroupingLevel.PROJECT:
            return "project";
        default:
            return "";
    }
};

TTDetailHTMLPreviewHeader.prototype._getNumberOfFloatingCells = function (detailCells) {
    let n = 0
    if (ReportPreviewUtils.checkGroupingLevel(ReportGroupingLevel.CUSTOMER, detailCells)){
        n++;
    }
    if (ReportPreviewUtils.checkGroupingLevel(ReportGroupingLevel.TASK, detailCells)){
        n++;
    }
    if (ReportPreviewUtils.checkGroupingLevel(ReportGroupingLevel.PROJECT, detailCells)){
        n++;
    }
    return n;
};


// WEBPACK FOOTER //
// ./web/js/reports/preview/html/ttdetail/TTDetailHTMLPreviewHeader.js